import React, { useEffect } from "react";
import AdminLogin from "../../components/admin/AdminLogin";

const AdminLoginPage = () => {

   useEffect(() => {
            document.body.id = "admin-login-001";
          }, []);
  return (
    <div>
      <AdminLogin />
    </div>
  );
};

export default AdminLoginPage;
